import { render, staticRenderFns } from "./busIndex.vue?vue&type=template&id=fc04c960&scoped=true&"
import script from "./busIndex.vue?vue&type=script&lang=js&"
export * from "./busIndex.vue?vue&type=script&lang=js&"
import style0 from "./busIndex.vue?vue&type=style&index=0&id=fc04c960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc04c960",
  null
  
)

export default component.exports